import { PORTAL_ROUTE } from 'src/constants/routes';

const fmt = (value, loading) => (loading ? '...' : (value ?? 0).toLocaleString());

export const policyDetailsTabs = (policyId, counts, loading = false) => [
  {
    label: `General`,
    value: `${PORTAL_ROUTE}/policy-details/${policyId}/general`,
  },
  {
    label: `Versions (${fmt(counts?.versionsCount, loading)})`,
    value: `${PORTAL_ROUTE}/policy-details/${policyId}/versions`,
  },
  {
    // Counts the devices running the policy; the tab also lists the ones without it.
    label: `Devices (${fmt(counts?.devicesCount, loading)})`,
    value: `${PORTAL_ROUTE}/policy-details/${policyId}/devices`,
  },
];
